import { useEffect, useState } from "react";

export const Modifier = ({ items }) => {
    const [state, setState] = useState([]);
    useEffect(() => setState(items), [items]);  
       
    if (!items) return null;

    return (
        <div>
            {state.map(({id, name }) => (
                <div
                    key={id}
                    className="bg-gray-50 sm:rounded-lg my-2 mx-auto pl-20 py-3 w-full text-sm font-medium"
                >
                    {name}                 
                </div>
            ))}
        </div>
    );
};